<template>
  <div>
    <h2 class="mb-8 grey--text">
      {{ $t('recharge.otherInformations') }}
    </h2>

    <v-row>
      <v-col>
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="holder.name"
          :rules="[rules.required]"
          :label="$t('forms.completeName')"
          hide-details="auto"
          outlined
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5">
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="holder.email"
          :rules="[rules.email]"
          :label="$t('forms.email')"
          hide-details="auto"
          outlined
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="document"
          v-mask="document.length <= 14 ? mask.cpfCnpj.cpf : mask.cpfCnpj.cnpj"
          :rules="[rules.documentCheck]"
          :label="$t('forms.cpfCnpj')"
          hide-details="auto"
          outlined
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="phoneNumber"
          v-mask="
            phoneNumber.length >= 15 ? mask.phone.phone9 : mask.phone.phone8
          "
          :rules="[rules.phoneValidation]"
          :label="$t('forms.phone')"
          hide-details="auto"
          outlined
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="address"
          :label="$t('appointment.formCreate.labels.address')"
          :rules="[rules.required]"
          hide-details="auto"
          outlined
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="holder.address_number"
          :label="$t('appointment.formCreate.labels.streetNumber')"
          :rules="[rules.required]"
          hide-details="auto"
          outlined
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="holder.postal_code"
          v-mask="'#####-###'"
          :label="$t('appointment.formCreate.labels.postalCode')"
          :rules="[rules.required]"
          hide-details="auto"
          outlined
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-textarea
          v-model="comment"
          @input="handleUpdateRechargeFields"
          :label="$t('recharge.comment')"
          hide-details="auto"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { email, phone as phoneValidation, documentCheck } from '@/util/errorHandling'
import { mapGetters, mapMutations } from 'vuex'
import { cpfCnpj, phone } from '@/util/masks'

export default {
  name: 'RechargePersonalFields',

  data() {
    return {
      address: '',
      document: '',
      phoneNumber: '',
      comment: null,

      holder: {
        name: null,
        email: null,
        cpf_cnpj: null,
        postal_code: null,
        phone: null,
        address_number: null,
      },

      rules: {
        email,
        phoneValidation,
        documentCheck,
        required: (val) => !!val || 'Obrigatório',
        min: (val) => (!!val && val.length >= 7) || 'Obrigatório',
      },

      mask: { cpfCnpj, phone },
    }
  },

  watch: {
    document() {
      this.holder.cpf_cnpj = this.document.replace(/[^\d]+/g, '')
    },

    phoneNumber() {
      this.holder.phone = this.phoneNumber.replace(/[^\d]+/g, '')
    },
  },

  computed: {
    ...mapGetters(['rechargeFields']),
  },

  methods: {
    ...mapMutations(['setRechargeFields']),

    handleUpdateRechargeFields() {
      const { credit_card } = this.rechargeFields

      this.setRechargeFields({
        credit_card: {
          ...{ info: credit_card.info },
          ...{ holder: this.holder },
        },
        ...{ comment: this.comment }
      })
    },
  },
}
</script>
